import React, { useEffect } from "react";
import { Button, Modal } from "antd";
import "./pro-modal.less"; 

interface ProDisplayModalProps {
  type: "info" | "success" | "error" | "warning";
  title?: React.ReactNode | string; 
  className?: string; 
  content: React.ReactNode | string;
  buttons?: string[];
  icon?: null; 
  onButtonClick?: (buttonLabel: string, buttonIndex: number) => void;
  showOnMount?: boolean;
}

const ProDisplayModal: React.FC<ProDisplayModalProps> = ({
  type,
  title,
  className,
  content,
  buttons, 
  onButtonClick, 
  showOnMount = true, 
}) => {
  // Memoize the handleButtonClick inside useEffect to avoid unnecessary re-renders
  // and ensure the correct closure for onButtonClick if it's dynamic
  useEffect(() => {
    const displayModal = () => {
      const modalConfig: any = {
        className: className || "",
        content: content,
        // onOk and onCancel are often overridden by 'footer' when custom buttons are used
      };

      if (title) {
        modalConfig.title = title;
      }

      if (buttons && buttons.length > 0) {
        modalConfig.footer = (
          <div style={{ display: "flex", justifyContent: "flex-end", paddingTop: 16 }}>
            {buttons.map((label, index) => (
              <Button
                key={label + index}
                type={
                  index === 0 
                    ? "primary"
                    : label.toLowerCase() === "ok" 
                    ? "primary"
                    : "default"
                }
                className={index === 0 ? "modal-primary-button" : ""} 
                onClick={() => {
                  if (onButtonClick) {
                    onButtonClick(label, index); 
                  }
                  Modal.destroyAll(); 
                }}
                style={{ marginLeft: index > 0 ? 8 : 0 }}
              >
                {label}
              </Button>
            ))}
          </div>
        );
      } 

      switch (type) {
        case "info":
          Modal.info(modalConfig);
          break;
        case "success":
          Modal.success(modalConfig);
          break;
        case "error":
          Modal.error(modalConfig);
          break;
        case "warning":
          modalConfig.icon = null; 
          Modal.warning(modalConfig);
          break;
        default:
          Modal.info(modalConfig); // Fallback to info
      }
    };

    if (showOnMount) {
      displayModal();
    }
  }, []);

  return null;
};

export default ProDisplayModal;